import { Link } from "react-router";
import { Footprints } from "lucide-react";
import { cn } from "@/lib/utils/cn";

export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      className={cn("flex size-8 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-accent to-primary text-white shadow-sm dark:from-accent dark:to-accent/60 dark:text-primary-fg", className)}
      aria-hidden
    >
      <Footprints className="size-[60%]" />
    </span>
  );
}

export function Brand({ collapsed = false, to = "/", className }: { collapsed?: boolean; to?: string; className?: string }) {
  return (
    <Link to={to} className={cn("flex items-center gap-2.5 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50", className)} aria-label="PB-Ranks home">
      <BrandMark />
      {!collapsed && <span className="font-display text-lg font-bold tracking-tight">PB-Ranks</span>}
    </Link>
  );
}
